// Informations affichées sur le site (contact, éditeur).
import { t } from '@shared/i18n';

export const CONTACT_EMAIL = 'followmeapp.lu@gmail.com';
export const PUBLISHER = 'Christian Saint-Croix';
export const APP_NAME = 'FollowMe';
/** date de dernière mise à jour des textes légaux */
export const LEGAL_UPDATED = '20 octobre 2026';
export const LEGAL_UPDATED_EN = '20 October 2026';
/** la même date dans la langue du site */
export const legalUpdated = () => t(LEGAL_UPDATED, LEGAL_UPDATED_EN);
